export const chatQueryKeys = {
  all: ['chats'] as const,
  lists: () => [...chatQueryKeys.all, 'list'] as const,
  list: (tenantId: string) => [...chatQueryKeys.lists(), tenantId] as const,
  detail: (chatId: string) => [...chatQueryKeys.all, 'detail', chatId] as const,
};

export const chatMutationKeys = {
  /** A message being sent in a chat: the open chat stops checking for news meanwhile (`useChatQuery`). */
  send: [...chatQueryKeys.all, 'send'] as const,
  /** A click on Confirm or Cancel under a change Finlay proposed. */
  decide: [...chatQueryKeys.all, 'decide'] as const,
};
